import { defineMessages } from '@transcend-io/internationalization';

// Define the messages
export const buttonMessages = defineMessages(
  'pc-core-components.Button.button',
  {
    loading: {
      defaultMessage: 'Loading...',
    },
  },
);
